/** @jsxImportSource theme-ui */
import { useRouter } from "next/router";
import Image from "next/image";
import CreamLogo from "../../../public/img/logo.svg";
import BlueLogo from "../../../public/img/logo-dark-blue.svg";
import Link from "next/link";
import { useUser } from "@auth0/nextjs-auth0";

interface HeaderLogoProps {
  theme: "BLUE" | "CREAM";
}
const HeaderLogo = ({ theme }: HeaderLogoProps) => {
  const { user } = useUser();
  const logo = theme === "CREAM" ? CreamLogo : BlueLogo;

  return (
    <div
      sx={{
        width: ["129px", null, "184px"],
        zIndex: "front",
        ":hover": {
          cursor: "pointer",
        },
      }}
    >
      <Link href={user ? "/dashboard" : "/"} passHref={true}>
        <a>
          <Image
            src={logo}
            alt="Bodycam Report logo"
            width={184}
            height={40}
            priority
          />
        </a>
      </Link>
    </div>
  );
};

export default HeaderLogo;
